"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", [_c("html", [_c("head"), _c("body", [_c("h1", [_vm._v("万视智营微组件库")]), _c("blockquote", [_c("p", [_vm._v("基于 "), _c("code", {
    pre: true
  }, [_vm._v("ant-design-vue")]), _vm._v(" 及智营系统业务要求进行二次封装的组件。")])]), _c("p", [_vm._v("重点注意事项：")]), _c("ol", [_c("li", [_c("code", {
    pre: true
  }, [_vm._v("frd-dev")]), _vm._v("和"), _c("code", {
    pre: true
  }, [_vm._v("frd-master")]), _vm._v("分支属于"), _c("code", {
    pre: true
  }, [_vm._v("福瑞达定制化项目特定拥有的分支")]), _vm._v("，福瑞达项目的需求基于这两个分支进行开发。在开发和测试阶段只能在"), _c("code", {
    pre: true
  }, [_vm._v("frd-dev")]), _vm._v("分支上进行开发，上线后合并到"), _c("code", {
    pre: true
  }, [_vm._v("frd-master")]), _vm._v("分支。")]), _c("li", [_c("code", {
    pre: true
  }, [_vm._v("dev")]), _vm._v("和"), _c("code", {
    pre: true
  }, [_vm._v("master")]), _vm._v("分支属于之前项目使用的分支。")]), _c("li", [_vm._v("如果是修复通用性的bug，需同步合并到"), _c("code", {
    pre: true
  }, [_vm._v("frd-master")]), _vm._v("和"), _c("code", {
    pre: true
  }, [_vm._v("master")]), _vm._v("分支。")])]), _c("h2", [_vm._v("基础组件")]), _c("ul", [_c("li", [_vm._v("基础组件以 "), _c("code", {
    pre: true
  }, [_vm._v("Basis")]), _vm._v(" 命名开头，会自动全局注册，可直接使用。这类组件不包括具体的业务逻辑。")])]), _c("h2", [_vm._v("业务组件")]), _c("ul", [_c("li", [_vm._v("除了以 "), _c("code", {
    pre: true
  }, [_vm._v("Basis")]), _vm._v(" 命名开头的组件外的其他组件，需要在使用时手动引入、注册。")])]), _c("h2", [_vm._v("使用该组件库的准备工作")]), _c("ol", [_c("li", [_vm._v("由于微组件中使用到 "), _c("code", {
    pre: true
  }, [_vm._v("axios")]), _vm._v(" 请求，"), _c("code", {
    pre: true
  }, [_vm._v("import axios from '@/utils/axios'")]), _vm._v("。要求主项目中必须有相应文件。目前智营项目对"), _c("code", {
    pre: true
  }, [_vm._v("axios")]), _vm._v("二次封装的文件都是统一放在"), _c("code", {
    pre: true
  }, [_vm._v("@/utils/axios")]), _vm._v("文件")]), _c("li", [_vm._v("组件 "), _c("code", {
    pre: true
  }, [_vm._v("BasisShopLevelTreeSelect")]), _vm._v(" 和 "), _c("code", {
    pre: true
  }, [_vm._v("BasisShopListToSelect")]), _vm._v(" 使用到 "), _c("code", {
    pre: true
  }, [_vm._v("pinyin")]), _vm._v(" 依赖，需运行 "), _c("code", {
    pre: true
  }, [_vm._v("yarn add pinyin")]), _vm._v(" 进行安装")]), _c("li", [_vm._v("组件 "), _c("code", {
    pre: true
  }, [_vm._v("VirtualScrollListToSelect")]), _vm._v(" 使用到 "), _c("code", {
    pre: true
  }, [_vm._v("vue-virtual-scroller")]), _vm._v("依赖，需运行 "), _c("code", {
    pre: true
  }, [_vm._v("yarn add vue-virtual-scroller")]), _vm._v(" 进行安装")]), _c("li", [_vm._v("组件 "), _c("code", {
    pre: true
  }, [_vm._v("ReportSubjectEditor")]), _vm._v(" 使用到 "), _c("code", {
    pre: true
  }, [_vm._v("sortablejs ^1.15.0")]), _vm._v("依赖，需运行 "), _c("code", {
    pre: true
  }, [_vm._v("yarn add sortablejs")]), _vm._v(" 进行安装")]), _c("li", [_vm._v("组件 "), _c("code", {
    pre: true
  }, [_vm._v("BasisDownloadExcel")]), _vm._v(" 使用到 "), _c("code", {
    pre: true
  }, [_vm._v("exceljs")]), _vm._v(" 和 "), _c("code", {
    pre: true
  }, [_vm._v("file-saver")]), _vm._v(" 依赖，需运行 "), _c("code", {
    pre: true
  }, [_vm._v("yarn add exceljs file-saver")]), _vm._v(" 进行安装")]), _c("li", [_vm._v("组件 "), _c("code", {
    pre: true
  }, [_vm._v("ReportSubjectEditor")]), _vm._v(" 使用到 "), _c("code", {
    pre: true
  }, [_vm._v("vcolorpicker")]), _vm._v("依赖，需运行 "), _c("code", {
    pre: true
  }, [_vm._v("yarn add vcolorpicker@1.1.0")]), _vm._v(" 进行安装，并在"), _c("code", {
    pre: true
  }, [_vm._v("main.js")]), _vm._v("中注册：")])]), _c("pre", {
    pre: true
  }, [_c("code", {
    pre: true,
    attrs: {
      "v-pre": "",
      class: "language-js"
    }
  }, [_vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-keyword"
    }
  }, [_vm._v("import")]), _vm._v(" vcolorpicker "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-keyword"
    }
  }, [_vm._v("from")]), _vm._v(" "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-string"
    }
  }, [_vm._v("'vcolorpicker'")]), _vm._v("\n "), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-title class_"
    }
  }, [_vm._v("Vue")]), _vm._v("."), _c("span", {
    pre: true,
    attrs: {
      class: "hljs-title function_"
    }
  }, [_vm._v("use")]), _vm._v("(vcolorpicker)\n")])]), _c("h2", [_vm._v("组件列表")]), _c("table", [_c("thead", [_c("tr", [_c("th", [_vm._v("组件名称")]), _c("th", [_vm._v("描述")])])]), _c("tbody", [_c("tr", [_c("td", [_vm._v("BasisCopyright")]), _c("td", [_vm._v("版权信息")])]), _c("tr", [_c("td", [_vm._v("BasisDownloadExcel")]), _c("td", [_vm._v("把JSON数据导出为Excel文件，依赖"), _c("code", {
    pre: true
  }, [_vm._v("exceljs")]), _vm._v("和"), _c("code", {
    pre: true
  }, [_vm._v("file-saver")]), _vm._v("第三方npm包")])]), _c("tr", [_c("td", [_vm._v("BasisIcon")]), _c("td", [_vm._v("基础图标组件，支持自定义svg图标、IconFont图标以及AntDesignVue的Icon图标组件")])]), _c("tr", [_c("td", [_vm._v("BasisInfiniteSelect")]), _c("td", [_vm._v("无限下拉选择器，支持本地数据或通过method进行远程获取")])]), _c("tr", [_c("td", [_vm._v("BasisModal")]), _c("td", [_vm._v("模态对话框，基于"), _c("code", {
    pre: true
  }, [_vm._v("AModal")]), _vm._v("二次封装，"), _c("strong", [_vm._v("业务中全部使用该组件代替"), _c("code", {
    pre: true
  }, [_vm._v("AModal")]), _vm._v("的使用")])])]), _c("tr", [_c("td", [_vm._v("BasisNoPermission")]), _c("td", [_vm._v("没有权限提示组件")])]), _c("tr", [_c("td", [_vm._v("BasisPlanningTips")]), _c("td", [_vm._v("功能模块规划中的提示图")])]), _c("tr", [_c("td", [_vm._v("BasisSearchForm")]), _c("td", [_vm._v("基础搜索表单组件，已集成到"), _c("code", {
    pre: true
  }, [_vm._v("BasisTableLayout")]), _vm._v("中作为头部搜索")])]), _c("tr", [_c("td", [_vm._v("BasisShopLevelTreeSelect")]), _c("td", [_vm._v("店铺层级树选择器组件，基于"), _c("code", {
    pre: true
  }, [_vm._v("ATreeSelect")]), _vm._v("进行二次封装。"), _c("strong", [_c("code", {
    pre: true
  }, [_vm._v("目前大部分场景下选择店铺或层级都是使用该组件")])])])]), _c("tr", [_c("td", [_vm._v("BasisShopListToSelect")]), _c("td", [_vm._v("店铺列表选择组件，基于"), _c("code", {
    pre: true
  }, [_vm._v("VirtualScrollListToSelect")]), _vm._v("二次封装，通过无限滚动列表的方式选择店铺")])]), _c("tr", [_c("td", [_vm._v("BasisTable")]), _c("td", [_vm._v("基础表格组件，基于"), _c("code", {
    pre: true
  }, [_vm._v("ATable")]), _vm._v("二次封装，新增了表头横向拖拽改变单元格宽度、表头筛选、跨页多选、树型数据勾选等功能")])]), _c("tr", [_c("td", [_vm._v("BasisTableLayout")]), _c("td", [_vm._v("集成搜索"), _c("code", {
    pre: true
  }, [_vm._v("BasisSearchForm")]), _vm._v("、表格展示"), _c("code", {
    pre: true
  }, [_vm._v("BasisTable")]), _vm._v("、分页功能的业务布局组件，在大部分表格数据展示的场景中都是使用该组件即可，比较少单独使用到"), _c("code", {
    pre: true
  }, [_vm._v("BasisTable")]), _vm._v("组件")])]), _c("tr", [_c("td", [_vm._v("BasisUpload")]), _c("td", [_vm._v("文件上传组件，基于"), _c("code", {
    pre: true
  }, [_vm._v("AUpload")]), _vm._v("二次封装，支持通过服务端上传文件到七牛云。"), _c("code", {
    pre: true
  }, [_vm._v("TODO：阿里云OSS(当前业务暂不需要，故不做支持)")])])]), _c("tr", [_c("td", [_vm._v("CostItemTableTree")]), _c("td", [_vm._v("科目分类展示及选择组件，目前主要用于编辑智能报表时选择科目，"), _c("code", {
    pre: true
  }, [_vm._v("已集成到ReportSubjectEditor组件中，较少单独使用")])])]), _c("tr", [_c("td", [_vm._v("CustomImportDataModal")]), _c("td", [_vm._v("导入数据弹框，"), _c("code", {
    pre: true
  }, [_vm._v("目前大部分导入数据业务都统一使用该组件")])])]), _c("tr", [_c("td", [_vm._v("CustomSelectListModal")]), _c("td", [_vm._v("选择列表模态框组件，适用于通过点击“添加”按钮，弹出模态框选择列表后通过table展示数据，并支持修改某个字段值的业务场景。如“添加货品”")])]), _c("tr", [_c("td", [_vm._v("CustomSelectSpecModal")]), _c("td", [_vm._v("选择货品模态框组件，基于"), _c("code", {
    pre: true
  }, [_vm._v("CustomSelectListModal")]), _vm._v("二次封装")])]), _c("tr", [_c("td", [_vm._v("CustomSelectUserModal")]), _c("td", [_vm._v("选择员工模态框组件，该组件一般用于通过弹框形式从组织架构中选择员工")])]), _c("tr", [_c("td", [_vm._v("CustomSyncDataModal")]), _c("td", [_vm._v("更新/导出数据模态框组件，弹框中的表单包括日期选择组件"), _c("code", {
    pre: true
  }, [_vm._v("ARangePicker")]), _vm._v("和店铺层级选择组件"), _c("code", {
    pre: true
  }, [_vm._v("BasisShopLevelTreeSelect")])])]), _c("tr", [_c("td", [_vm._v("ExportBlobToExcel")]), _c("td", [_vm._v("把通过后台接口返回的Blob格式数据导出为Excel文档，已集成到"), _c("code", {
    pre: true
  }, [_vm._v("CustomImportDataModal")]), _vm._v("组件中，用于下载模板")])]), _c("tr", [_c("td", [_vm._v("FormulaEditor")]), _c("td", [_vm._v("公式编辑组件，用于编辑计算公式，支持普通的数字运算、从科目库添加科目、选择已有公式科目。"), _c("br"), _vm._v("目前使用到的应用场景包括：租户后台的公共报表、业绩解码项目的智能报表、智能看板等模块中的计算公式编辑。")])]), _c("tr", [_c("td", [_vm._v("InputNumberRange")]), _c("td", [_vm._v("数字区间组件")])]), _c("tr", [_c("td", [_vm._v("ReportSubjectEditor")]), _c("td", [_vm._v("报表添加科目组件，用于为智能报表、智能看板添加科目。")])]), _c("tr", [_c("td", [_vm._v("VirtualScrollListToSelect")]), _c("td", [_vm._v("虚拟滚动列表选择组件（支持多选、单选）。"), _c("br"), _vm._v("一次性加载的长列表单选或多选时使用。如“店铺列表选择”、“用户列表选择”等业务场景。"), _c("br"), _vm._v("通过虚拟滚动列表解决页面长列表卡顿问题。")])])])])])])]);
}];
render._withStripped = true;